export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6799.3657babb.jpg";